// Best-effort POST to /api/complete-registration (first-login onboarding:
// Slack + Google-name persistence). Shared by the magic-link confirm flow
// (auth-confirm.ts) and the Google OAuth callback (auth-callback.ts). Errors
// are logged, never thrown — onboarding side effects must not block sign-in.
export async function postCompleteRegistration(
  accessToken: string,
): Promise<void> {
  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort();
  }, 8000);
  try {
    await fetch("/api/complete-registration", {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
      signal: controller.signal,
    });
  } catch (err) {
    console.error("complete-registration failed", err);
  } finally {
    clearTimeout(timeout);
  }
}
